import React, {useContext, useEffect, useState} from 'react'
import { StateContext } from '../../context/GlobalState.jsx'
import {Col, Container, Row, Spinner} from "react-bootstrap";
import ReactPaginate from 'react-paginate';

function Pages(props) {
    let {getParts, offset, setOffset, perPage, parts, pageCount} = useContext(StateContext);
    const [selPage, setSelPage] = useState(0);

    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setSelPage(e.selected);
        setOffset(selectedPage * perPage)

    };


    useEffect(() => {
      //  getParts(props.modelId)

        if(props.modelId){
            getParts(props.modelId)
            setSelPage(0);
            setOffset(0 * perPage);
        }else {
            getParts()

        }



    }, [props.modelId])

    useEffect(() => {
        if(props.modelId){
            getParts(props.modelId)
        }else {
            getParts()
        }

        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [offset])


    // render JSX
    return (
        <div >
            <Container>
                <Row className="center-text">
                    <Col>

                        <div className="App">
                            <div>
                                <section className="products">
                                    {parts.length > 0 ? parts :  <div className="center-text items padTop"><Spinner animation="border" /></div>}
                                </section>
                            </div>

                        </div>
                    </Col>

                </Row>
                <Row className="center-text">
                    <Col>
                        {pageCount > 0 ? <ReactPaginate
                            hrefBuilder={(page, pageCount, selected) =>
                                page >= 1 && page <= pageCount ? `/allcatalog/${page}` : '#'
                            }
                            hrefAllControls
                            forcePage={selPage}
                            previousLabel={"<"}
                            nextLabel={">"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={pageCount}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            onPageChange={handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} /> :  ""}

                    </Col>

                </Row>
            </Container>


        </div>
    )
}

export default Pages
